import React from 'react';
import nkyLogo from '../../../assets/images/logoNoWords.png';
import {
  SpinnerRoot,
  SpinnerRing,
  SpinnerPlate,
  SpinnerLogo,
} from './NkySpinner.styled';

/**
 * Branded loading indicator — teal→blue ring with NKY Connect mark.
 *
 * @param {'sm'|'md'|'lg'} [size='md']
 * @param {boolean} [onDark=false] Use when shown on a dark/scrim background
 * @param {string} [label='Loading'] Accessible status label
 * @param {object} [sx] Optional MUI sx merged onto the root
 */
function NkySpinner({
  size = 'md',
  onDark = false,
  label = 'Loading',
  className,
  sx,
  ...rest
}) {
  return (
    <SpinnerRoot
      $size={size}
      className={className}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label}
      sx={sx}
      {...rest}
    >
      <SpinnerRing className="nky-spinner-ring" $size={size} aria-hidden />
      <SpinnerPlate className="nky-spinner-plate" $size={size} $onDark={onDark}>
        <SpinnerLogo
          src={nkyLogo}
          alt=""
          $size={size}
          $onDark={onDark}
          draggable={false}
        />
      </SpinnerPlate>
    </SpinnerRoot>
  );
}

export default NkySpinner;
